(function() {
  function initProductListSection(wrapper) {
    if (!wrapper || wrapper.dataset.apparelInitialized === 'true') return;
    wrapper.dataset.apparelInitialized = 'true';

    var sectionId = wrapper.dataset.sectionId || '';
    var sectionRoot = sectionId ? document.getElementById('shopify-section-' + sectionId) : wrapper.closest('[id^="shopify-section-"]');
    var pageSize = parseInt(wrapper.dataset.pageSize || '15', 10);
    if (isNaN(pageSize) || pageSize < 1) pageSize = 15;
    var currentPage = 1;
    var collectionUrl = wrapper.dataset.collectionUrl || '';
    var storageKey = 'apparel-columns-' + sectionId;

    if (wrapper.hasAttribute('data-apparel-scroll-fade')) {
      function apparelScrollReveal() {
        wrapper.classList.add('apparelcollection--enter');
      }
      try {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          apparelScrollReveal();
        } else if ('IntersectionObserver' in window) {
          var apparelFadeIo = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
              if (entry.isIntersecting) {
                apparelScrollReveal();
                apparelFadeIo.disconnect();
              }
            });
          }, { root: null, rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
          apparelFadeIo.observe(wrapper);
        } else {
          apparelScrollReveal();
        }
      } catch (e) {
        apparelScrollReveal();
      }
    }

    var grid = sectionId ? document.getElementById('ApparelGrid-' + sectionId) : wrapper.querySelector('[data-apparel-grid]');
    var paginationEl = wrapper.querySelector('[data-apparel-pagination]');
    var pageNumbersEl = wrapper.querySelector('[data-apparel-page-numbers]');
    var prevPageBtn = wrapper.querySelector('[data-apparel-page-prev]');
    var nextPageBtn = wrapper.querySelector('[data-apparel-page-next]');
    var noResultsEl = wrapper.querySelector('[data-apparel-no-results]');
    var filterTrigger = wrapper.querySelector('[data-apparel-filter-trigger]');
    var filterDrawer = wrapper.querySelector('[data-apparel-filter-drawer]');
    var filterBackdrop = wrapper.querySelector('[data-apparel-filter-backdrop]');
    var filterClose = wrapper.querySelector('[data-apparel-filter-close]');
    var filterApply = wrapper.querySelector('[data-apparel-filter-apply]');
    var filterReset = wrapper.querySelector('[data-apparel-filter-reset]');
    var priceMinRange = wrapper.querySelector('[data-filter-price-min-range]');
    var priceMaxRange = wrapper.querySelector('[data-filter-price-max-range]');
    var priceProgress = wrapper.querySelector('[data-filter-price-progress]');
    var filterHistoryOpen = false;
    var filterCloseCleanupTimer = null;
    var filterCloseTransitionHandler = null;
    var filterFocusReturn = null;

    function updatePriceSliderProgress(minVal, maxVal, maxLimit) {
      if (!priceProgress || !maxLimit) return;
      var startPct = (minVal / maxLimit) * 100;
      var endPct = (maxVal / maxLimit) * 100;
      priceProgress.style.left = startPct + '%';
      priceProgress.style.right = (100 - endPct) + '%';
    }

    function initPriceRangeControls() {
      if (!grid || !priceMinRange || !priceMaxRange) return;
      var minInput = filterDrawer ? filterDrawer.querySelector('[data-filter-price-min]') : null;
      var maxInput = filterDrawer ? filterDrawer.querySelector('[data-filter-price-max]') : null;
      var maxPriceFromProducts = 50;

      grid.querySelectorAll('.grid__item[data-price]').forEach(function(item) {
        var priceCents = parseInt(item.getAttribute('data-price') || '0', 10);
        var price = Math.ceil(priceCents / 100);
        if (price > maxPriceFromProducts) maxPriceFromProducts = price;
      });

      var maxLimit = Math.ceil(maxPriceFromProducts / 10) * 10;
      if (maxLimit < 50) maxLimit = 50;

      priceMinRange.max = String(maxLimit);
      priceMaxRange.max = String(maxLimit);
      if (minInput) minInput.max = String(maxLimit);
      if (maxInput) maxInput.max = String(maxLimit);

      var currentMin = minInput && minInput.value !== '' ? parseInt(minInput.value, 10) : 0;
      var currentMax = maxInput && maxInput.value !== '' ? parseInt(maxInput.value, 10) : maxLimit;
      if (isNaN(currentMin)) currentMin = 0;
      if (isNaN(currentMax)) currentMax = maxLimit;
      if (currentMin > currentMax) currentMin = currentMax;

      priceMinRange.value = String(currentMin);
      priceMaxRange.value = String(currentMax);
      if (minInput) minInput.value = String(currentMin);
      if (maxInput) maxInput.value = String(currentMax);
      updatePriceSliderProgress(currentMin, currentMax, maxLimit);

      priceMinRange.addEventListener('input', function() {
        var minVal = parseInt(priceMinRange.value, 10);
        var maxVal = parseInt(priceMaxRange.value, 10);
        if (minVal > maxVal) {
          minVal = maxVal;
          priceMinRange.value = String(minVal);
        }
        if (minInput) minInput.value = String(minVal);
        updatePriceSliderProgress(minVal, maxVal, maxLimit);
      });

      priceMaxRange.addEventListener('input', function() {
        var minVal = parseInt(priceMinRange.value, 10);
        var maxVal = parseInt(priceMaxRange.value, 10);
        if (maxVal < minVal) {
          maxVal = minVal;
          priceMaxRange.value = String(maxVal);
        }
        if (maxInput) maxInput.value = String(maxVal);
        updatePriceSliderProgress(minVal, maxVal, maxLimit);
      });

      if (minInput) {
        minInput.addEventListener('input', function() {
          var minVal = parseInt(minInput.value || '0', 10);
          var maxVal = parseInt(priceMaxRange.value, 10);
          if (isNaN(minVal)) minVal = 0;
          if (minVal > maxVal) minVal = maxVal;
          priceMinRange.value = String(minVal);
          minInput.value = String(minVal);
          updatePriceSliderProgress(minVal, maxVal, maxLimit);
        });
      }

      if (maxInput) {
        maxInput.addEventListener('input', function() {
          var maxVal = parseInt(maxInput.value || String(maxLimit), 10);
          var minVal = parseInt(priceMinRange.value, 10);
          if (isNaN(maxVal)) maxVal = maxLimit;
          if (maxVal < minVal) maxVal = minVal;
          priceMaxRange.value = String(maxVal);
          maxInput.value = String(maxVal);
          updatePriceSliderProgress(minVal, maxVal, maxLimit);
        });
      }
    }

    function getFocusableElements(container) {
      if (!container) return [];
      return Array.prototype.slice.call(container.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )).filter(function(el) {
        return el.offsetParent !== null || el === document.activeElement;
      });
    }

    function trapFilterFocus(event) {
      if (!filterDrawer || !filterDrawer.classList.contains('is-open') || event.key !== 'Tab') return;
      var focusable = getFocusableElements(filterDrawer);
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    function openFilterDrawer() {
      if (!filterDrawer || !filterBackdrop || !filterTrigger) return;
      if (filterCloseCleanupTimer) {
        clearTimeout(filterCloseCleanupTimer);
        filterCloseCleanupTimer = null;
      }
      if (filterCloseTransitionHandler) {
        filterDrawer.removeEventListener('transitionend', filterCloseTransitionHandler);
        filterCloseTransitionHandler = null;
      }
      filterFocusReturn = document.activeElement;
      if (sectionRoot) sectionRoot.classList.add('apparelcollection--filter-open');
      filterDrawer.classList.add('is-open');
      filterBackdrop.classList.add('is-open');
      filterTrigger.classList.add('is-open');
      filterDrawer.setAttribute('aria-hidden', 'false');
      filterTrigger.setAttribute('aria-expanded', 'true');
      document.addEventListener('keydown', trapFilterFocus);
      var focusable = getFocusableElements(filterDrawer);
      if (focusable.length) focusable[0].focus();
      if (window.history && window.history.pushState && !filterHistoryOpen) {
        window.history.pushState({ apparelFilterOpen: true }, '', window.location.href);
        filterHistoryOpen = true;
      }
    }

    function closeFilterDrawer() {
      if (!filterDrawer || !filterBackdrop || !filterTrigger) return;
      filterDrawer.classList.remove('is-open');
      filterBackdrop.classList.remove('is-open');
      filterTrigger.classList.remove('is-open');
      filterDrawer.setAttribute('aria-hidden', 'true');
      filterTrigger.setAttribute('aria-expanded', 'false');
      document.removeEventListener('keydown', trapFilterFocus);
      filterHistoryOpen = false;
      if (filterFocusReturn && typeof filterFocusReturn.focus === 'function') {
        filterFocusReturn.focus();
      }
      if (sectionRoot) {
        if (filterCloseTransitionHandler) {
          filterDrawer.removeEventListener('transitionend', filterCloseTransitionHandler);
        }
        filterCloseTransitionHandler = function() {
          if (!filterDrawer.classList.contains('is-open')) {
            sectionRoot.classList.remove('apparelcollection--filter-open');
          }
          filterCloseTransitionHandler = null;
        };
        filterDrawer.addEventListener('transitionend', filterCloseTransitionHandler, { once: true });
        if (filterCloseCleanupTimer) clearTimeout(filterCloseCleanupTimer);
        filterCloseCleanupTimer = setTimeout(function() {
          if (!filterDrawer.classList.contains('is-open')) {
            sectionRoot.classList.remove('apparelcollection--filter-open');
          }
          filterCloseCleanupTimer = null;
        }, 360);
      }
    }

    function matchesPriceFilter(priceCents, minPrice, maxPrice) {
      var price = priceCents / 100;
      var minOk = minPrice === null || price >= minPrice;
      var maxOk = maxPrice === null || price <= maxPrice;
      return minOk && maxOk;
    }

    function updateNoResultsState() {
      if (!grid || !noResultsEl) return;
      var visibleCount = 0;
      grid.querySelectorAll('.grid__item[data-index]').forEach(function(item) {
        if (!item.classList.contains('apparelcollection__item--filtered-out')) visibleCount += 1;
      });
      noResultsEl.hidden = visibleCount > 0;
    }

    function applyDrawerFilters() {
      if (!grid) return;
      var availabilityInputs = filterDrawer ? filterDrawer.querySelectorAll('[data-filter-availability]') : [];
      var availabilityFilters = [];
      var priceMinInput = filterDrawer ? filterDrawer.querySelector('[data-filter-price-min]') : null;
      var priceMaxInput = filterDrawer ? filterDrawer.querySelector('[data-filter-price-max]') : null;
      var minPrice = null;
      var maxPrice = null;

      availabilityInputs.forEach(function(input) {
        if (input.checked) availabilityFilters.push(input.getAttribute('data-filter-availability'));
      });
      if (priceMinInput && priceMinInput.value !== '') {
        var parsedMin = parseFloat(priceMinInput.value);
        if (!isNaN(parsedMin) && parsedMin >= 0) minPrice = parsedMin;
      }
      if (priceMaxInput && priceMaxInput.value !== '') {
        var parsedMax = parseFloat(priceMaxInput.value);
        if (!isNaN(parsedMax) && parsedMax >= 0) maxPrice = parsedMax;
      }
      if (minPrice !== null && maxPrice !== null && minPrice > maxPrice) {
        var swap = minPrice;
        minPrice = maxPrice;
        maxPrice = swap;
      }

      var items = grid.querySelectorAll('.grid__item[data-index]');
      items.forEach(function(item) {
        var isAvailable = item.getAttribute('data-available') === 'true';
        var priceCents = parseInt(item.getAttribute('data-price') || '0', 10);
        var availabilityMatch = true;

        if (availabilityFilters.length) {
          availabilityMatch = availabilityFilters.some(function(filterKey) {
            if (filterKey === 'in-stock') return isAvailable;
            if (filterKey === 'out-of-stock') return !isAvailable;
            return true;
          });
        }

        var priceMatch = matchesPriceFilter(priceCents, minPrice, maxPrice);
        item.classList.toggle('apparelcollection__item--filtered-out', !(availabilityMatch && priceMatch));
      });

      updateNoResultsState();
      applyPagination(1);
    }

    function getPageableItems() {
      if (!grid) return [];
      return Array.from(grid.querySelectorAll('.grid__item[data-index]')).filter(function(item) {
        return !item.classList.contains('apparelcollection__item--filtered-out');
      });
    }

    function renderPagination(totalPages) {
      if (!paginationEl || !pageNumbersEl) return;
      if (totalPages <= 1) {
        paginationEl.hidden = true;
        pageNumbersEl.innerHTML = '';
        return;
      }

      paginationEl.hidden = false;
      if (prevPageBtn) prevPageBtn.disabled = currentPage <= 1;
      if (nextPageBtn) nextPageBtn.disabled = currentPage >= totalPages;

      pageNumbersEl.innerHTML = '';
      for (var page = 1; page <= totalPages; page++) {
        var pageBtn = document.createElement('button');
        pageBtn.type = 'button';
        pageBtn.className = 'apparelcollection__page-btn' + (page === currentPage ? ' is-active' : '');
        pageBtn.textContent = String(page);
        pageBtn.setAttribute('aria-label', 'Page ' + page);
        if (page === currentPage) {
          pageBtn.setAttribute('aria-current', 'page');
        } else {
          pageBtn.setAttribute('data-apparel-page', String(page));
        }
        pageNumbersEl.appendChild(pageBtn);
      }
    }

    function applyPagination(page) {
      var items = getPageableItems();
      var totalPages = Math.max(1, Math.ceil(items.length / pageSize));
      currentPage = Math.min(Math.max(1, page || 1), totalPages);
      var start = (currentPage - 1) * pageSize;
      var end = start + pageSize;

      if (grid) {
        grid.querySelectorAll('.grid__item[data-index]').forEach(function(item) {
          item.classList.add('apparelcollection__item--hidden');
        });
        items.forEach(function(item, idx) {
          if (idx >= start && idx < end) {
            item.classList.remove('apparelcollection__item--hidden');
          }
        });
        grid.setAttribute('data-pagination-ready', 'true');
      }

      renderPagination(totalPages);
    }

    function goToPage(page) {
      applyPagination(page);
      if (!grid) return;
      var gridTop = grid.getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo({ top: Math.max(0, gridTop - 24), behavior: 'smooth' });
    }

    function applyApparelOsSwatch(card, swatch) {
      if (!card || !swatch) return;
      var image = card.querySelector('[data-apparel-os-image]');
      var mediaLink = card.querySelector('[data-apparel-os-link]');
      var titleLink = card.querySelector('[data-apparel-os-title-link]');
      var priceCurrent = card.querySelector('[data-apparel-os-price-current]');
      var priceCompare = card.querySelector('[data-apparel-os-price-compare]');
      var preview = swatch.getAttribute('data-preview');
      var previewSrcset = swatch.getAttribute('data-preview-srcset');
      var previewAlt = swatch.getAttribute('data-preview-alt');
      var price = swatch.getAttribute('data-price');
      var compare = swatch.getAttribute('data-compare');
      var productUrl = swatch.getAttribute('data-product-url');
      var gridItem = card.closest('.grid__item');

      if (image && preview) {
        image.src = preview;
        if (previewSrcset) {
          image.srcset = previewSrcset;
        } else {
          image.removeAttribute('srcset');
        }
        if (previewAlt) image.alt = previewAlt;
      }

      if (mediaLink && productUrl) mediaLink.setAttribute('href', productUrl);
      if (titleLink && productUrl) titleLink.setAttribute('href', productUrl);
      if (priceCurrent && price) priceCurrent.textContent = price;
      if (priceCompare) {
        if (compare) {
          priceCompare.textContent = compare;
          priceCompare.hidden = false;
        } else {
          priceCompare.textContent = '';
          priceCompare.hidden = true;
        }
      }
      if (gridItem && swatch.getAttribute('data-price-cents')) {
        gridItem.setAttribute('data-price', swatch.getAttribute('data-price-cents'));
      }

      card.querySelectorAll('.apparel-os-swatch').forEach(function(activeSwatch) {
        activeSwatch.classList.remove('is-active');
        activeSwatch.setAttribute('aria-pressed', 'false');
      });
      swatch.classList.add('is-active');
      swatch.setAttribute('aria-pressed', 'true');
    }

    function bindApparelOsSwatches(root) {
      if (!root) return;
      root.querySelectorAll('[data-apparel-os-card]').forEach(function(card) {
        if (card.dataset.apparelSwatchesBound === 'true') return;
        card.dataset.apparelSwatchesBound = 'true';
        card.querySelectorAll('.apparel-os-swatch').forEach(function(swatch) {
          swatch.addEventListener('focus', function() {
            applyApparelOsSwatch(card, swatch);
          });
          swatch.addEventListener('click', function(event) {
            event.preventDefault();
            event.stopPropagation();
            applyApparelOsSwatch(card, swatch);
          });
        });
      });
    }

    function setColumnLayout(cols, btns, options) {
      if (!grid) return;
      options = options || {};
      var wasListView = grid.classList.contains('is-list-view');

      btns.forEach(function(b) {
        b.classList.toggle('is-active', b.dataset.columns === cols);
      });

      if (cols === 'list') {
        var match = grid.className.match(/grid--[234]-col-desktop/);
        if (match) {
          grid.dataset.savedColClass = match[0];
          grid.classList.remove(match[0]);
        }
        grid.classList.add('is-list-view');
        grid.dataset.columns = 'list';
      } else {
        grid.classList.remove('is-list-view');
        var restoreClass = grid.dataset.savedColClass;
        if (restoreClass) {
          grid.classList.add(restoreClass);
          delete grid.dataset.savedColClass;
        }
        grid.className = grid.className.replace(/grid--[234]-col-desktop/g, 'grid--' + cols + '-col-desktop');
        grid.classList.remove('grid--1-col-tablet-down');
        grid.classList.add('grid--2-col-tablet-down');
        grid.dataset.columns = cols;
      }

      if (options.persist !== false) {
        try {
          localStorage.setItem(storageKey, cols);
        } catch (e) { /* ignore */ }
      }

      applyPagination(currentPage);

      if (!options.skipScroll && cols === 'list' && !wasListView && !window.matchMedia('(min-width: 768px)').matches) {
        requestAnimationFrame(function() {
          var gridTop = grid.getBoundingClientRect().top + window.pageYOffset;
          var offset = 24;
          window.scrollTo({ top: Math.max(0, gridTop - offset), behavior: 'smooth' });
        });
      }
    }

    if (grid) {
      applyPagination(1);
      initPriceRangeControls();
      updateNoResultsState();

      bindApparelOsSwatches(grid);

      var btns = wrapper.querySelectorAll('.apparelcollection__column-btn');
      var desktopMq = window.matchMedia('(min-width: 768px)');
      var userPickedColumns = false;
      var desktopColumns = grid.getAttribute('data-desktop-columns') || '3';

      btns.forEach(function(btn) {
        btn.addEventListener('click', function() {
          userPickedColumns = true;
          setColumnLayout(this.dataset.columns, btns);
        });
      });

      if (!desktopMq.matches) {
        setColumnLayout('list', btns, { skipScroll: true, persist: false });
      } else {
        try {
          var savedCols = localStorage.getItem(storageKey);
          if (savedCols && wrapper.querySelector('.apparelcollection__column-btn[data-columns="' + savedCols + '"]')) {
            setColumnLayout(savedCols, btns, { skipScroll: true, persist: false });
          }
        } catch (e) { /* ignore */ }
      }

      function onDesktopMqChange(event) {
        if (userPickedColumns) return;
        if (event.matches) {
          var restoreCols = desktopColumns;
          try {
            var storedCols = localStorage.getItem(storageKey);
            if (storedCols && wrapper.querySelector('.apparelcollection__column-btn[data-columns="' + storedCols + '"]')) {
              restoreCols = storedCols;
            }
          } catch (e) { /* ignore */ }
          setColumnLayout(restoreCols, btns, { skipScroll: true, persist: false });
        } else {
          setColumnLayout('list', btns, { skipScroll: true, persist: false });
        }
      }
      if (desktopMq.addEventListener) {
        desktopMq.addEventListener('change', onDesktopMqChange);
      } else if (desktopMq.addListener) {
        desktopMq.addListener(onDesktopMqChange);
      }
    }

    if (filterTrigger && filterDrawer && filterBackdrop) {
      filterTrigger.addEventListener('click', function() {
        if (filterDrawer.classList.contains('is-open')) closeFilterDrawer();
        else openFilterDrawer();
      });

      if (filterClose) filterClose.addEventListener('click', closeFilterDrawer);
      filterBackdrop.addEventListener('click', closeFilterDrawer);

      document.addEventListener('click', function(event) {
        if (!filterDrawer.classList.contains('is-open')) return;
        if (!filterDrawer.contains(event.target) && !filterTrigger.contains(event.target)) {
          closeFilterDrawer();
        }
      });

      document.addEventListener('keydown', function(event) {
        if (event.key === 'Escape' && filterDrawer.classList.contains('is-open')) {
          closeFilterDrawer();
        }
      });

      window.addEventListener('popstate', function() {
        if (filterDrawer.classList.contains('is-open')) closeFilterDrawer();
      });

      if (filterApply) {
        filterApply.addEventListener('click', function() {
          applyDrawerFilters();
          closeFilterDrawer();
        });
      }

      if (filterReset) {
        filterReset.addEventListener('click', function() {
          filterDrawer.querySelectorAll('input[type="checkbox"]').forEach(function(input) {
            input.checked = false;
          });
          var minInput = filterDrawer.querySelector('[data-filter-price-min]');
          var maxInput = filterDrawer.querySelector('[data-filter-price-max]');
          if (minInput) minInput.value = '0';
          if (maxInput) maxInput.value = priceMaxRange ? priceMaxRange.max : '50';
          if (priceMinRange) priceMinRange.value = '0';
          if (priceMaxRange) priceMaxRange.value = priceMaxRange.max;
          updatePriceSliderProgress(
            priceMinRange ? parseInt(priceMinRange.value, 10) : 0,
            priceMaxRange ? parseInt(priceMaxRange.value, 10) : 50,
            priceMaxRange ? parseInt(priceMaxRange.max, 10) : 50
          );
          applyDrawerFilters();
          closeFilterDrawer();
        });
      }
    }

    if (paginationEl) {
      if (prevPageBtn) {
        prevPageBtn.addEventListener('click', function() {
          if (currentPage > 1) goToPage(currentPage - 1);
        });
      }
      if (nextPageBtn) {
        nextPageBtn.addEventListener('click', function() {
          goToPage(currentPage + 1);
        });
      }
      if (pageNumbersEl) {
        pageNumbersEl.addEventListener('click', function(event) {
          var target = event.target.closest('[data-apparel-page]');
          if (!target) return;
          var page = parseInt(target.getAttribute('data-apparel-page'), 10);
          if (!isNaN(page)) goToPage(page);
        });
      }
    }

    var sortSelect = sectionId ? document.getElementById('ApparelSort-' + sectionId) : wrapper.querySelector('[data-apparel-sort]');
    var sortTrigger = wrapper.querySelector('[data-apparel-sort-trigger]');
    var sortList = wrapper.querySelector('[data-apparel-sort-list]');

    if (sortSelect && sortTrigger && sortList) {
      var triggerText = sortTrigger.querySelector('.apparelcollection__sort-trigger-text');
      var options = sortList.querySelectorAll('.apparelcollection__sort-option');
      var focusedOptionIndex = -1;

      function setTriggerText() {
        var opt = sortSelect.options[sortSelect.selectedIndex];
        if (triggerText) triggerText.textContent = opt ? opt.textContent : '';
      }

      function closeList() {
        sortList.classList.remove('is-open');
        sortTrigger.setAttribute('aria-expanded', 'false');
        focusedOptionIndex = -1;
        sortList.addEventListener('transitionend', function onEnd() {
          sortList.removeEventListener('transitionend', onEnd);
          sortList.hidden = true;
        }, { once: true });
      }

      function openList() {
        sortList.hidden = false;
        sortTrigger.setAttribute('aria-expanded', 'true');
        requestAnimationFrame(function() {
          sortList.classList.add('is-open');
        });
      }

      function selectOption(opt) {
        var val = opt.getAttribute('data-value');
        if (val && sortSelect.value !== val) {
          sortSelect.value = val;
          sortSelect.dispatchEvent(new Event('change', { bubbles: true }));
        }
        options.forEach(function(o) {
          o.classList.remove('is-selected');
          o.setAttribute('aria-selected', 'false');
        });
        opt.classList.add('is-selected');
        opt.setAttribute('aria-selected', 'true');
        setTriggerText();
        closeList();
        sortTrigger.focus();
      }

      setTriggerText();
      options.forEach(function(opt, index) {
        opt.setAttribute('aria-selected', opt.classList.contains('is-selected') ? 'true' : 'false');
        opt.addEventListener('click', function(e) {
          e.stopPropagation();
          selectOption(this);
        });
        opt.dataset.optionIndex = String(index);
      });

      sortTrigger.addEventListener('click', function(e) {
        e.stopPropagation();
        if (sortList.hidden) openList();
        else closeList();
      });

      sortTrigger.addEventListener('keydown', function(e) {
        if (e.key === 'ArrowDown' || e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          if (sortList.hidden) openList();
        }
      });

      sortList.addEventListener('keydown', function(e) {
        var optionArr = Array.prototype.slice.call(options);
        if (e.key === 'Escape') {
          e.preventDefault();
          closeList();
          sortTrigger.focus();
        } else if (e.key === 'ArrowDown') {
          e.preventDefault();
          focusedOptionIndex = Math.min(focusedOptionIndex + 1, optionArr.length - 1);
          optionArr[focusedOptionIndex].focus();
        } else if (e.key === 'ArrowUp') {
          e.preventDefault();
          focusedOptionIndex = Math.max(focusedOptionIndex - 1, 0);
          optionArr[focusedOptionIndex].focus();
        } else if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          if (document.activeElement && document.activeElement.classList.contains('apparelcollection__sort-option')) {
            selectOption(document.activeElement);
          }
        }
      });

      document.addEventListener('click', function() { closeList(); });
    }

    if (sortSelect && grid) {
      var items = grid.querySelectorAll('.grid__item[data-position]');

      function sortGrid(sortBy) {
        if (!items.length) return;
        grid.classList.add('apparelcollection__grid--sorting');
        var list = Array.from(items);
        var compare = function(a, b) {
          switch (sortBy) {
            case 'title-ascending':
              return (a.dataset.title || '').localeCompare(b.dataset.title || '');
            case 'title-descending':
              return (b.dataset.title || '').localeCompare(a.dataset.title || '');
            case 'created-descending':
              return parseInt(b.dataset.published || 0, 10) - parseInt(a.dataset.published || 0, 10);
            case 'created-ascending':
              return parseInt(a.dataset.published || 0, 10) - parseInt(b.dataset.published || 0, 10);
            case 'price-ascending':
              return parseFloat(a.dataset.price || 0) - parseFloat(b.dataset.price || 0);
            case 'price-descending':
              return parseFloat(b.dataset.price || 0) - parseFloat(a.dataset.price || 0);
            case 'manual':
            case 'best-selling':
            default:
              return parseInt(a.dataset.position || 0, 10) - parseInt(b.dataset.position || 0, 10);
          }
        };
        list.sort(compare);
        requestAnimationFrame(function() {
          list.forEach(function(node) { grid.appendChild(node); });
          applyPagination(1);
          requestAnimationFrame(function() {
            grid.classList.remove('apparelcollection__grid--sorting');
          });
        });
      }

      sortSelect.addEventListener('change', function() {
        var value = this.value;
        if (collectionUrl && wrapper.dataset.sortMode === 'server') {
          var target = new URL(collectionUrl, window.location.origin);
          target.searchParams.set('sort_by', value);
          window.location.href = target.toString();
          return;
        }
        sortGrid(value);
        if (window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('sort_by', value);
          window.history.replaceState({}, '', url.toString());
        }
      });

      var urlSort = new URLSearchParams(window.location.search).get('sort_by');
      if (urlSort && Array.prototype.slice.call(sortSelect.options).some(function(o) { return o.value === urlSort; })) {
        sortSelect.value = urlSort;
        if (wrapper.dataset.sortMode !== 'server') sortGrid(urlSort);
        if (sortTrigger && sortList) {
          var triggerTextEl = sortTrigger.querySelector('.apparelcollection__sort-trigger-text');
          if (triggerTextEl) triggerTextEl.textContent = sortSelect.options[sortSelect.selectedIndex].textContent;
          sortList.querySelectorAll('.apparelcollection__sort-option').forEach(function(o) {
            var selected = o.getAttribute('data-value') === sortSelect.value;
            o.classList.toggle('is-selected', selected);
            o.setAttribute('aria-selected', selected ? 'true' : 'false');
          });
        }
      }
    }
  }

  function boot() {
    document.querySelectorAll('.apparelcollection[data-section-id]').forEach(initProductListSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function(event) {
    var section = event.target;
    if (!section) return;
    var wrapper = section.querySelector('.apparelcollection[data-section-id]');
    if (wrapper) initProductListSection(wrapper);
  });
})();
